export default "__VITE_ASSET__BqYjD24h__"